<template>
  <div
    :class="['btn-wraper', { offline_offsite_wraper: offline_offsite }]"
    v-show="show"
  >
    <p v-if="offline_offsite" class="text-link">
      <span @click="showSite">{{ offline_offsite.title }}</span>
    </p>
    <input
      type="button"
      :value="btnTitle"
      :class="{ 'btn-photoinfo': 1, 'btn-photoinfo-active': 1 }"
      :style="choosedKey ? finishedBtnStyle : unfinishedBtnStyle"
      @click="goNext"
    />
    <offline-site
      ref="offlineSite"
      :config="offline_offsite || {}"
    ></offline-site>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

import OfflineSite from "../base/offline-site.vue";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";
import { SUPPORT_COUNTRY } from "../../tools/constant";
import { showAlertDialog } from "../../tools/Tip";

export default {
  props: ["formItem", "choosedKey", "choosedInfo", "idx", "omegaItem"],
  components: { OfflineSite },
  data() {
    return {
      ends,
    };
  },
  computed: {
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    offline_offsite() {
      return this.formItem["attach-link"];
    },
    show() {
      let end = getEnd();
      let d = this.formItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
    submitBtn() {
      return this.formItem.button_color || { un_check: {}, is_check: {} };
    },
    finishedBtnStyle() { //已选择角色
      let btnColor = this.submitBtn.is_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border || 'none'
      }
    },
    unfinishedBtnStyle() { //未选择角色
      let btnColor = this.submitBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border
      }
    },
    btnTitle() {
      return this.choosedKey ? this.submitBtn.is_check.title : this.submitBtn.un_check.title;
    }
  },
  methods: {
    ...mapMutations(["setState"]),
    showSite() {
      if (this.offline_offsite.target == "blank") {
        location.href = this.offline_offsite.link;
        return;
      }
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    goResult() {
      if (!this.choosedKey) {
        showAlertDialog(this, this.formItem.submit_tip);
      } else {
        // showDialog(this, {
        //   type: "confirm",
        //   content: this.$t("typeInfo.submit_tips").replace(
        //     /{role}/,
        //     this.identityInfo[this.identity].title
        //   ),
        //   icon: "cubeic-alert",
        //   confirmBtn: {
        //     text: this.$t("typeInfo.OK"),
        //   },
        //   cancelBtn: { text: this.$t("typeInfo.Back") },
        //   onConfirm: this.handleSubmit,
        // });
      }
    },
    goNext() {
      // 不提交信息,暂存在store中，在baseInfo页面中一起提交
      if (!this.choosedKey) return;
      try {
        Omega.trackEvent("ibt_gd_selection_next_btn_ck", "", {
          ...this.omegaItem,
          identity_id: this.choosedInfo.identify_type,
          product_id: this.choosedInfo.product_type,
          click_time: new Date().getTime()
        });
        // gtm({ 'event': 's5ObIdSelection',
        //   'Identity': this._identity,
        //   'error': 'false' })
      } catch (e) {}
      let r = SUPPORT_COUNTRY[this.location_country]||"Mx";
      let routerMap = {
        productInfoNew: `productInfo`,
        typeInfoNew: `typeInfo`,
        basicInfo: `baseInfo${r}`,
        auditInfo: `photoInfo${r}`,
        resultInfo: `resultRoleInfo${r}`,
      }
      //@20190729 跳转前重置城市选项,产品线不同城市不同,基础信息页根据后端缓存或定位设置
      this.setState({
        _area: {
          text: "",
          value: ""
        }
      });
      this.$router.push({
        name: `${routerMap[this.choosedInfo.next_step]}`,
      });
    },
  },
  mounted() {
    
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.btn-wraper {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.43rem 0.31rem;
  background: #fff;
  box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.04);
  .btn-photoinfo {
    width: 6.84rem;
    height: 1.06rem;
    font-size: 0.36rem;
    font-weight: 700;
    color: #999;
    text-align: center;
    background-color: #eee;
    border-radius: 0.12rem;
  }
  .btn-photoinfo-active {
    color: #fff;
    background: linear-gradient(45deg, #ff5b1d, #ff7f41);
  }
}
.has-img-fixed .btn-wraper {
  bottom: 3.9rem;
}
</style>
